import React from 'react';
import { Typography } from 'antd';

const EmptyChatState = () => {
	return (
		<div className="flex flex-1 flex-col items-center justify-center h-full">
			<Typography.Title level={4}>AI insights</Typography.Title>
			<Typography.Text type="secondary">
				Start a new chat to explore AI powered exam insights.
			</Typography.Text>
		</div>
	);
};

export default EmptyChatState;
